import { useLoadingCallback } from '@/lib/hooks'
import { AxiosResponse } from 'axios'
import axiosInstance from '../axios'

type RequestPasswordRecovery = (data: {
  email: string
}) => Promise<AxiosResponse>
export type UsePasswordRecoveryMutation = () => [
  passwordRecovery: RequestPasswordRecovery,
  isLoading: boolean
]

export const usePasswordRecoveryMutation: UsePasswordRecoveryMutation = () =>
  useLoadingCallback<RequestPasswordRecovery>(data =>
    axiosInstance.post('/v3/auth/forgot-password', data)
  )
